import { Link, useNavigate } from "react-router-dom";
import { ShoppingCart, User, Menu, Phone, Mail, LogOut, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    user,
    signOut
  } = useAuth();
  const navigate = useNavigate();
  const {
    data: isAdmin
  } = useQuery({
    queryKey: ["isAdmin", user?.id],
    queryFn: async () => {
      if (!user) return false;
      const {
        data
      } = await supabase.from("user_roles").select("role").eq("user_id", user.id).eq("role", "admin").maybeSingle();
      return !!data;
    },
    enabled: !!user
  });
  const navigation = [{
    name: "Početna",
    href: "/"
  }, {
    name: "Proizvodi",
    href: "/proizvodi"
  }, {
    name: "O Nama",
    href: "/o-nama"
  }, {
    name: "Kontakt",
    href: "/kontakt"
  }, {
    name: "FAQ",
    href: "/faq"
  }];
  return <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4">
        {/* Top bar */}
        <div className="flex items-center justify-between py-2 text-sm border-b">
          <div className="flex items-center gap-4">
            <a href="tel:+38267250197" className="flex items-center gap-1 text-muted-foreground hover:text-primary transition-fast">
              <Phone className="h-4 w-4" />
              <span className="hidden sm:inline">+382 67 250 197</span>
            </a>
            <a href="mailto:ell.mont10@gmail.com" className="flex items-center gap-1 text-muted-foreground hover:text-primary transition-fast">
              <Mail className="h-4 w-4" />
              <span className="hidden sm:inline">ell.mont10@gmail.com</span>
            </a>
          </div>
          <div className="text-muted-foreground">Besplatna dostava za porudžbine preko 50€</div>
        </div>

        {/* Main navigation */}
        <div className="flex items-center justify-between py-4">
          <Link to="/" className="flex items-center gap-2">
            <div className="gradient-primary text-white px-3 py-2 rounded-lg font-bold text-xl">
              ELL-MONT
            </div>
          </Link>

          {/* Desktop navigation */}
          <nav className="hidden md:flex items-center gap-6">
            {navigation.map(item => <Link key={item.name} to={item.href} className="text-foreground hover:text-primary transition-fast font-medium">
                {item.name}
              </Link>)}
          </nav>

          {/* Actions */}
          <div className="flex items-center gap-2">
            {user ? <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="ghost" size="icon">
                    <User className="h-5 w-5" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                  <DropdownMenuItem asChild>
                    <Link to="/nalog">Moj Nalog</Link>
                  </DropdownMenuItem>
                  {isAdmin && <DropdownMenuItem onClick={() => navigate("/admin")}>
                      <Shield className="h-4 w-4 mr-2" />
                      Admin Panel
                    </DropdownMenuItem>}
                  <DropdownMenuItem onClick={() => signOut()}>
                    <LogOut className="h-4 w-4 mr-2" />
                    Odjava
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu> : <Button variant="ghost" size="icon" asChild>
                <Link to="/prijava" aria-label="Prijava">
                  <User className="h-5 w-5" />
                </Link>
              </Button>}
            
            <Button variant="ghost" size="icon" asChild className="relative">
              <Link to="/korpa" aria-label="Korpa za kupovinu">
                <ShoppingCart className="h-5 w-5" />
                <span aria-hidden="true" className="absolute -top-1 -right-1 bg-accent text-accent-foreground text-xs rounded-full h-5 w-5 flex items-center justify-center">
                  0
                </span>
              </Link>
            </Button>

            {/* Mobile menu */}
            <Sheet open={isOpen} onOpenChange={setIsOpen}>
              <SheetTrigger asChild className="md:hidden">
                <Button variant="ghost" size="icon" aria-label="Otvori meni">
                  <Menu className="h-5 w-5" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[300px]">
                <nav className="flex flex-col gap-4 mt-8">
                  {navigation.map(item => <Link key={item.name} to={item.href} onClick={() => setIsOpen(false)} className="text-lg font-medium hover:text-primary transition-fast">
                      {item.name}
                    </Link>)}
                </nav>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>;
};
export default Header;